import { FeatureFlagEnum } from 'shared/interfaces/environment.interface';
import { getFeatureFlag } from 'shared/util/feature-flag.utils';
import { PermissionAccessZoneEnum, PermissionJSONLevel, ShijiPermissionsEnum } from '../interfaces/permissions.interface';

const listingContentPermissions: PermissionJSONLevel = {
    listingProfile: {
        type: 'resource',
        resourceName: 'listingProfile',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    conferenceEvent: {
        type: 'resource',
        resourceName: 'conferenceEvent',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    distribution: {
        type: 'resource',
        resourceName: 'distribution',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    entertainment: {
        type: 'resource',
        resourceName: 'entertainment',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    listingDetails: {
        type: 'resource',
        resourceName: 'listingDetails',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    foodAndBeverage: {
        type: 'resource',
        resourceName: 'foodAndBeverage',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    healthAndWellness: {
        type: 'resource',
        resourceName: 'healthAndWellness',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    location: {
        type: 'resource',
        resourceName: 'location',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    outlet: {
        type: 'resource',
        resourceName: 'outlet',
        minLevel: 'read',
        allowAnyAdmin: true,

        create: {
            type: 'resource',
            resourceName: 'outlet',
            minLevel: 'edit',
            allowAnyAdmin: true,
        },
        outletProfile: {
            type: 'resource',
            resourceName: 'outlet',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        entertainment: [
            {
                type: 'resource',
                resourceName: 'outlet',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
            {
                type: 'resource',
                resourceName: 'entertainment',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
        ],
        outletDetails: [
            {
                type: 'resource',
                resourceName: 'outlet',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
            {
                type: 'resource',
                resourceName: 'listingDetails',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
        ],
        foodAndBeverage: [
            {
                type: 'resource',
                resourceName: 'outlet',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
            {
                type: 'resource',
                resourceName: 'foodAndBeverage',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
        ],
        healthAndWellness: [
            {
                type: 'resource',
                resourceName: 'outlet',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
            {
                type: 'resource',
                resourceName: 'healthAndWellness',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
        ],
        policy: [
            {
                type: 'resource',
                resourceName: 'outlet',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
            {
                type: 'resource',
                resourceName: 'policy',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
        ],
        recreation: [
            {
                type: 'resource',
                resourceName: 'outlet',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
            {
                type: 'resource',
                resourceName: 'recreation',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
        ],
        safety: [
            {
                type: 'resource',
                resourceName: 'outlet',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
            {
                type: 'resource',
                resourceName: 'safety',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
        ],
        shopping: [
            {
                type: 'resource',
                resourceName: 'outlet',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
            {
                type: 'resource',
                resourceName: 'shopping',
                minLevel: 'read',
                allowAnyAdmin: true,
            },
        ],
        distribution: {
            type: 'resource',
            resourceName: 'distribution',
            allowAnyAdmin: true,
        },
    },
    rooms: {
        type: 'resource',
        resourceName: 'roomType',
        minLevel: 'read',
        allowAnyAdmin: true,
        new: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'create',
            allowAnyAdmin: true,
        },
        roomOverview: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        bedsInformation: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        bathroomInformation: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        distribution: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        roomInformation: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        roomTypeManager: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        accessibility: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        bathroom: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        children: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        climateControl: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        clothing: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        entertainment: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        features: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        kitchen: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        refreshments: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        roomLayout: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        safety: {
            type: 'resource',
            resourceName: 'roomType',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
    },
    policy: {
        type: 'resource',
        resourceName: 'policy',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    ratePlan: {
        type: 'resource',
        resourceName: 'ratePlan',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    recreation: {
        type: 'resource',
        resourceName: 'recreation',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    roomType: {
        type: 'resource',
        resourceName: 'roomType',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    safety: {
        type: 'resource',
        resourceName: 'safety',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    shopping: {
        type: 'resource',
        resourceName: 'shopping',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    visuals: {
        type: 'resource',
        resourceName: 'visuals',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    history: {
        type: 'resource',
        resourceName: 'listings',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    distributionTracking: {
        type: 'resource',
        resourceName: 'listings',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    listingOverview: {
        type: 'resource',
        resourceName: 'listings',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
};

const listingPermissionsSplitByVisuals: PermissionJSONLevel = {
    content: {
        ...listingContentPermissions,
    },
    visuals: {
        type: 'resource',
        resourceName: 'visuals',
        minLevel: 'read',
        allowAnyAdmin: true,
        assets: {
            type: 'resource',
            resourceName: 'visuals',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        photos: {
            type: 'resource',
            resourceName: 'visuals',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        listingProfile: {
            type: 'resource',
            resourceName: 'visuals',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        rooms: {
            type: 'resource',
            resourceName: 'visuals',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        roomTypeManager: {
            type: 'resource',
            resourceName: 'visuals',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        distribution: {
            type: 'resource',
            resourceName: 'visuals',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        history: {
            type: 'resource',
            resourceName: 'visuals',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        photoOrganizer: {
            type: 'resource',
            resourceName: 'visuals',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        categories: {
            type: 'resource',
            resourceName: 'visuals',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        imageTracker: {
            type: 'resource',
            resourceName: 'visuals',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
    },
};

const unifiedListingPermissions: PermissionJSONLevel = {
    ...listingContentPermissions,
    assets: {
        type: 'resource',
        resourceName: 'visuals',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    photos: {
        type: 'resource',
        resourceName: 'visuals',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    customContent: {
        type: 'resource',
        resourceName: 'visuals',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    roomTypeManager: {
        type: 'resource',
        resourceName: 'visuals',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    visualsDistribution: {
        type: 'resource',
        resourceName: 'visuals',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    photoOrganizer: {
        type: 'resource',
        resourceName: 'visuals',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    categories: {
        type: 'resource',
        resourceName: 'visuals',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
    imageTracker: {
        type: 'resource',
        resourceName: 'visuals',
        minLevel: 'read',
        allowAnyAdmin: true,
    },
};

const getListingPermissionsByFeatureFlag = (): PermissionJSONLevel => {
    if (getFeatureFlag(FeatureFlagEnum.UNIFIED_LISTING)) {
        return unifiedListingPermissions;
    }
    return getFeatureFlag(FeatureFlagEnum.CONTENT_VISUALS_SPLIT) ? listingPermissionsSplitByVisuals : listingContentPermissions;
};

export const permissions: PermissionJSONLevel = {
    users: {
        table: {
            create: {
                users: {
                    type: 'internal',
                    name: PermissionAccessZoneEnum.ACCESS_TO_USERS,
                    minLevel: 'invite',
                    allowAnyAdmin: true,
                },
                userGroups: {
                    type: 'internal',
                    name: PermissionAccessZoneEnum.ACCESS_TO_USER_GROUPS,
                    minLevel: 'edit',
                    allowAnyAdmin: true,
                },
                accessGroups: {
                    type: 'internal',
                    name: PermissionAccessZoneEnum.ACCESS_TO_LISTINGS_ACCESS_GROUPS,
                    minLevel: 'edit',
                    allowAnyAdmin: true,
                },
                shijiUsers: {
                    type: 'admin',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.SHIJI_PERMISSION,
                },
            },
        },
        tabs: {
            users: {
                type: 'internal',
                name: PermissionAccessZoneEnum.ACCESS_TO_USERS,
                minLevel: 'read',
                allowAnyAdmin: true,
            },
            invitedUsers: {
                type: 'internal',
                name: PermissionAccessZoneEnum.ACCESS_TO_USERS,
                minLevel: 'invite',
                allowAnyAdmin: true,
            },
            userGroups: {
                type: 'internal',
                name: PermissionAccessZoneEnum.ACCESS_TO_USER_GROUPS,
                minLevel: 'read',
                allowAnyAdmin: true,
            },
            accessGroups: {
                type: 'internal',
                name: PermissionAccessZoneEnum.ACCESS_TO_LISTINGS_ACCESS_GROUPS,
                minLevel: 'read',
                allowAnyAdmin: true,
            },
            shijiUsers: {
                type: 'admin',
                requiresSpecialAdminPermission: ShijiPermissionsEnum.SHIJI_PERMISSION,
            },
        },
    },
    sidebar: {
        listings: {
            type: 'resource',
            resourceName: 'listings',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        users: [
            [
                {
                    type: 'internal',
                    name: PermissionAccessZoneEnum.ACCESS_TO_USERS,
                    minLevel: 'read',
                    allowAnyAdmin: true,
                },
                {
                    type: 'internal',
                    name: PermissionAccessZoneEnum.ACCESS_TO_USER_GROUPS,
                    minLevel: 'read',
                    allowAnyAdmin: true,
                },
                {
                    type: 'internal',
                    name: PermissionAccessZoneEnum.ACCESS_TO_LISTINGS_ACCESS_GROUPS,
                    minLevel: 'read',
                    allowAnyAdmin: true,
                },
            ],
        ],
        settings: {
            type: 'resource',
            resourceName: 'customFields',
            minLevel: 'create',
            allowAnyAdmin: true,
        },
        exports: {
            type: 'resource',
            resourceName: 'distribution',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        icePortal: {
            type: 'resource',
            resourceName: 'visuals',
            minLevel: 'read',
            allowAnyAdmin: false,
            applicableToSupplierUsersOnly: true,
        },
    },
    listings: {
        delete: {
            type: 'resource',
            resourceName: 'listings',
            minLevel: 'delete',
            allowAnyAdmin: true,
        },
        create: {
            type: 'resource',
            resourceName: 'listings',
            minLevel: 'create',
            allowAnyAdmin: true,
        },
        saveOptions: {
            type: 'resource',
            resourceName: 'listings',
            minLevel: 'edit',
            allowAnyAdmin: true,

            saveOnly: {
                type: 'resource',
                resourceName: 'listings',
                minLevel: 'edit',
                allowAnyAdmin: true,
            },
            returnToEditor: {
                type: 'resource',
                resourceName: 'listings',
                minLevel: 'publish',
                allowAnyAdmin: true,
            },
            submitForApproval: {
                type: 'resource',
                resourceName: 'listings',
                minLevel: 'edit',
                maxLevel: 'delete',
                applicableToSupplierUsersOnly: true,
            },
            submitForPublishing: {
                type: 'resource',
                resourceName: 'listings',
                minLevel: 'publish',
                allowAnyAdmin: true,
            },
            discard: {
                type: 'resource',
                resourceName: 'listings',
                minLevel: 'edit',
                allowAnyAdmin: true,
            },
        },
        distribution: {
            type: 'resource',
            resourceName: 'distribution',
            minLevel: 'edit',
            allowAnyAdmin: true,
        },
        outletDelete: {
            type: 'resource',
            resourceName: 'outlet',
            minLevel: 'edit',
            allowAnyAdmin: true,
        },
        bulk: {
            delete: [
                {
                    type: 'internal',
                    name: PermissionAccessZoneEnum.ACCESS_TO_BULK_OPERATIONS,
                    minLevel: 'allow',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                {
                    type: 'resource',
                    resourceName: 'listings',
                    minLevel: 'delete',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
            ],
            publish: [
                {
                    type: 'internal',
                    name: PermissionAccessZoneEnum.ACCESS_TO_BULK_OPERATIONS,
                    minLevel: 'allow',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                {
                    type: 'resource',
                    resourceName: 'listings',
                    minLevel: 'publish',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
            ],
            edit: [
                {
                    type: 'internal',
                    name: PermissionAccessZoneEnum.ACCESS_TO_BULK_OPERATIONS,
                    minLevel: 'allow',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                {
                    type: 'resource',
                    resourceName: 'listings',
                    minLevel: 'edit',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
            ],
        },
    },
    dashboard: {
        reports: {
            type: 'resource',
            resourceName: 'listings',
            minLevel: 'read',
            allowAnyAdmin: true,
        },
        batchOperations: {
            type: 'admin',
            allowAnyAdmin: true,
        },
    },
    exports: {
        tabs: {
            'full-export': {
                type: 'admin',
                allowAnyAdmin: true,
            },
            monitoring: {
                type: 'admin',
                allowAnyAdmin: true,
            },
        },
    },
    urls: {
        listings: {
            type: 'resource',
            resourceName: 'listings',
            minLevel: 'read',
            allowAnyAdmin: true,

            'create-listing': {
                type: 'resource',
                resourceName: 'listings',
                minLevel: 'create',
                allowAnyAdmin: true,
            },
            details: {
                ...getListingPermissionsByFeatureFlag(),
            },
            bulk: {
                type: 'resource',
                resourceName: 'listings',
                minLevel: 'read',
                requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,

                listingProfile: {
                    type: 'resource',
                    resourceName: 'listingProfile',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                conferenceEvent: {
                    type: 'resource',
                    resourceName: 'conferenceEvent',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                distribution: {
                    type: 'resource',
                    resourceName: 'distribution',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                entertainment: {
                    type: 'resource',
                    resourceName: 'entertainment',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                listingDetails: {
                    type: 'resource',
                    resourceName: 'listingDetails',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                foodAndBeverage: {
                    type: 'resource',
                    resourceName: 'foodAndBeverage',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                healthAndWellness: {
                    type: 'resource',
                    resourceName: 'healthAndWellness',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                location: {
                    type: 'resource',
                    resourceName: 'location',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                // outlet: {
                //     type: 'resource',
                //     resourceName: "outlet",
                //     minLevel: 'read',
                //     allowAnyAdmin: true,
                //
                //     create: {
                //         type: 'resource',
                //         resourceName: "outlet",
                //         minLevel: 'edit',
                //         allowAnyAdmin: true,
                //     },
                //     outletProfile: {
                //         type: 'resource',
                //         resourceName: "outlet",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     },
                //     entertainment: [{
                //         type: 'resource',
                //         resourceName: "outlet",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }, {
                //         type: 'resource',
                //         resourceName: "entertainment",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }],
                //     outletDetails: [{
                //         type: 'resource',
                //         resourceName: "outlet",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }, {
                //         type: 'resource',
                //         resourceName: "listingDetails",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }],
                //     foodAndBeverage: [{
                //         type: 'resource',
                //         resourceName: "outlet",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }, {
                //         type: 'resource',
                //         resourceName: "foodAndBeverage",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }],
                //     healthAndWellness: [{
                //         type: 'resource',
                //         resourceName: "outlet",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }, {
                //         type: 'resource',
                //         resourceName: "healthAndWellness",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }],
                //     policy: [{
                //         type: 'resource',
                //         resourceName: "outlet",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }, {
                //         type: 'resource',
                //         resourceName: "policy",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }],
                //     recreation: [{
                //         type: 'resource',
                //         resourceName: "outlet",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }, {
                //         type: 'resource',
                //         resourceName: "recreation",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }],
                //     safety: [{
                //         type: 'resource',
                //         resourceName: "outlet",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }, {
                //         type: 'resource',
                //         resourceName: "safety",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }],
                //     shopping: [{
                //         type: 'resource',
                //         resourceName: "outlet",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }, {
                //         type: 'resource',
                //         resourceName: "shopping",
                //         minLevel: 'read',
                //         allowAnyAdmin: true
                //     }]
                // },
                policy: {
                    type: 'resource',
                    resourceName: 'policy',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                ratePlan: {
                    type: 'resource',
                    resourceName: 'ratePlan',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                recreation: {
                    type: 'resource',
                    resourceName: 'recreation',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                roomType: {
                    type: 'resource',
                    resourceName: 'roomType',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                safety: {
                    type: 'resource',
                    resourceName: 'safety',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                shopping: {
                    type: 'resource',
                    resourceName: 'shopping',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                visuals: {
                    type: 'resource',
                    resourceName: 'visuals',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                history: {
                    type: 'resource',
                    resourceName: 'listings',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                distributionTracking: {
                    type: 'resource',
                    resourceName: 'listings',
                    minLevel: 'read',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
                },
                listingOverview: {
                    type: 'resource',
                    resourceName: 'listings',
                    minLevel: 'read',
                },
            },
        },
        users: {
            users: [
                [
                    {
                        type: 'internal',
                        name: PermissionAccessZoneEnum.ACCESS_TO_USERS,
                        minLevel: 'read',
                        allowAnyAdmin: true,
                    },
                    {
                        type: 'internal',
                        name: PermissionAccessZoneEnum.ACCESS_TO_USER_GROUPS,
                        minLevel: 'read',
                        allowAnyAdmin: true,
                    },
                    {
                        type: 'internal',
                        name: PermissionAccessZoneEnum.ACCESS_TO_LISTINGS_ACCESS_GROUPS,
                        minLevel: 'read',
                        allowAnyAdmin: true,
                    },
                ],
            ],
            invitedUsers: {
                type: 'internal',
                name: PermissionAccessZoneEnum.ACCESS_TO_USERS,
                minLevel: 'invite',
                allowAnyAdmin: true,
            },
            userGroups: {
                type: 'internal',
                name: PermissionAccessZoneEnum.ACCESS_TO_USER_GROUPS,
                minLevel: 'read',
                allowAnyAdmin: true,
            },
            accessGroups: {
                type: 'internal',
                name: PermissionAccessZoneEnum.ACCESS_TO_LISTINGS_ACCESS_GROUPS,
                minLevel: 'read',
                allowAnyAdmin: true,
            },
            shijiUsers: {
                type: 'admin',
                requiresSpecialAdminPermission: ShijiPermissionsEnum.SHIJI_PERMISSION,
            },
        },
        settings: {
            type: 'resource',
            resourceName: 'customFields',
            minLevel: 'create',
            allowAnyAdmin: true,

            suppliers: {
                type: 'admin',
                allowAnyAdmin: true,

                'create-supplier': {
                    type: 'admin',
                    allowAnyAdmin: true,
                },
            },
            channels: {
                type: 'admin',
                allowAnyAdmin: true,

                'create-channel': {
                    type: 'admin',
                    allowAnyAdmin: true,
                },
            },
            brands: {
                type: 'admin',
                allowAnyAdmin: true,

                'create-brand': {
                    type: 'admin',
                    allowAnyAdmin: true,
                },
            },
            'api-access': {
                type: 'admin',
                allowAnyAdmin: true,

                'create-api-access': {
                    type: 'admin',
                    allowAnyAdmin: true,
                },
                'import-from-ice': {
                    type: 'admin',
                    allowAnyAdmin: true,
                },
            },
            'suppliers-ai-features': {
                type: 'admin',
                allowAnyAdmin: true,

                'enable-suppliers-ai-feature': {
                    type: 'admin',
                    allowAnyAdmin: true,
                },
            },
            fields: {
                type: 'resource',
                resourceName: 'customFields',
                minLevel: 'create',
                requiresSpecialAdminPermission: ShijiPermissionsEnum.CUSTOM_FIELDS,

                'create-field': {
                    type: 'resource',
                    resourceName: 'customFields',
                    minLevel: 'create',
                    requiresSpecialAdminPermission: ShijiPermissionsEnum.CUSTOM_FIELDS,
                },
            },
        },
        'export-management': {
            'full-export': {
                type: 'admin',
                requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
            },
            'imports-runner': {
                type: 'admin',
                requiresSpecialAdminPermission: ShijiPermissionsEnum.BULK_OPERATIONS,
            },
            'channel-distribution-status': {
                // Re-enable if we ever decide to allow supplier users to access this page
                // type: 'resource',
                // resourceName: 'distribution',
                // minLevel: 'read',
                // allowAnyAdmin: true,
                type: 'admin',
                allowAnyAdmin: true,
            },
            'exports-monitoring': {
                type: 'resource',
                resourceName: 'distribution',
                minLevel: 'read',
                allowAnyAdmin: true,
                allowWildcardRoutes: true,
            },
            'imports-monitoring': {
                type: 'admin',
                allowAnyAdmin: true,
                allowWildcardRoutes: true,
            },
        },
    },
};
